import * as React from 'react';
import { CheckboxField } from '@cian/components';

import { IJsonQueryRange } from '../../../../../../../json_query';
import { FromToControl } from '../../../../../../../common/components/from_to_control';
import { FOfferType, isUrban } from '../../../../../../../utils/category';
import { InlineParam } from '../../../markup';

const STAGE_MAX_LENGTH = 4;

export interface IFloorsTotalOwnProps {
  offerType: FOfferType;
}

export interface IFloorsTotalStoreProps {
  floorsTotal: IJsonQueryRange | undefined;
  isPenthouse: boolean;
}

export interface IFloorsTotalDispatchProps {
  onMinFloorsTotalChanged(value: number | undefined): void;
  onMaxFloorsTotalChanged(value: number | undefined): void;
  onIsPenthouseChange(value: boolean | undefined): void;
}

export type TFloorsTotalProps = IFloorsTotalOwnProps & IFloorsTotalStoreProps & IFloorsTotalDispatchProps;

export const FloorsTotal: React.StatelessComponent<TFloorsTotalProps> = props => {
  const {
    offerType,
    floorsTotal,
    onMinFloorsTotalChanged,
    onMaxFloorsTotalChanged,
    onIsPenthouseChange,
    isPenthouse,
  } = props;

  return (
    <>
      <InlineParam>
        <FromToControl
          rangeGroupStyle={{ width: 120 }}
          from={{
            value: floorsTotal && floorsTotal.value.gte,
            placeholder: 'от',
            onValueChange: onMinFloorsTotalChanged,
            maxLength: STAGE_MAX_LENGTH,
          }}
          to={{
            value: floorsTotal && floorsTotal.value.lte,
            placeholder: 'до',
            onValueChange: onMaxFloorsTotalChanged,
            maxLength: STAGE_MAX_LENGTH,
          }}
        />
      </InlineParam>
      {(isUrban(offerType) || isPenthouse) && (
        <InlineParam>
          <CheckboxField onValueChange={onIsPenthouseChange} value={isPenthouse} label="Пентхаус" />
        </InlineParam>
      )}
    </>
  );
};
